<template>
    <v-row>
        <v-col cols="12" sm="6" lg="4">
            <hourlist :start="yesterday" title="Gårsdagens Timer" key="yesterday" :step="1" unit="day" :cache="true" :key="'yesterday' + ($route.query.user || '')"></hourlist>
        </v-col>
        <v-col cols="12" sm="6" lg="4">
            <hourlist title="Dagens Timer" key="today" :step="1" unit="day" :cache="false" :key="'today' + ($route.query.user || '')" canAdd :user="user"></hourlist>
        </v-col>
        <v-col cols="12" sm="6" lg="4">
            <hourlist title="Ukes Timer" key="month" :step="1" unit="week" :cache="true" :key="'week' + ($route.query.user || '')"></hourlist>
            <hourlist title="Måneds Timer" key="month" :step="1" unit="month" :cache="true" :key="'month' + ($route.query.user || '')"></hourlist>
        </v-col>
    </v-row>
</template>
<script>
import moment from 'moment'
import Hourlist from '@/components/Hourlist.vue'
import api from '@/api'

export default {
    name: 'home',
    props:['user'],
    components: {
        Hourlist
    },
    data(){
        return {
            yesterday: moment().startOf('day').subtract(1, "day"),
            users: []
        }
    }
}
</script>